import React, { useState } from "react";
import "../../index.css";
import { FiInstagram, FiTwitter, FiLinkedin } from "react-icons/fi";

const CardProfile = ({
  name,
  role,
  description,
  imageUrl,
  socialLinks,
  logoUrl = "/cato.webp",
  objectPosition,
  objectPositionHover = "center center",
  scaleHover = 2.5,
}) => {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className="card_profile"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <button className="mail">
        <img src={logoUrl} alt="Logo" className="w-12 h-12" />
      </button>

      <div className="profile-pic">
        <img
          src={imageUrl}
          className="object-cover rounded-lg"
          alt={name}
          style={{
            objectPosition: hovered ? objectPositionHover : objectPosition,
            transform: hovered ? `scale(${scaleHover})` : "scale(1)",
          }}
        />
      </div>

      <div className="bottom">
        <div className="content">
          <span className="name font-main font-bold text-lg">{name}</span>
          <span className="about-me font-main font-medium font-md">
            {description}
          </span>
        </div>
        <div className="bottom-bottom">
          <div className="social-links-container">
            <a href={socialLinks.instagram}>
              <FiInstagram
                className="text-gray-950 hover:text-gray-200 cursor-pointer"
                size={24}
              />
            </a>
            <a href={socialLinks.twitter}>
              <FiTwitter
                className="text-gray-950 hover:text-gray-200 cursor-pointer"
                size={24}
              />
            </a>
            <a href={socialLinks.linkedin}>
              <FiLinkedin
                className="text-gray-950 hover:text-gray-200 cursor-pointer"
                size={24}
              />
            </a>
          </div>
          <button className="button_profile font-main font-medium text-xs">
            {role}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CardProfile;
